import { RiskLevel } from "@/model/RiskLevel";
import { DefaultHigh, DefaultLower, NullBanner } from "@/model/DefaultBanners";
const IncreasingBanner = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking.
 Click here to <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/haringey"
};
const HigherBanner = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://bookdrinkcoach.as.me/haringey"
};
export default {
    name: "Haringey",
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingBanner,
        [RiskLevel.Higher]: HigherBanner,
        [RiskLevel.High]: DefaultHigh
    },
    clinics: [
        {
            name: "Haringey Recovery Service",
            times: [
                {
                    title: "Appointments:",
                    info: "<br>To find out more about the service or to make a self-referral please call or email to arrange an appointment 0208 801 3999 <a href='mailto:humankind.haga590hrs@nhs.net'>humankind.haga590hrs@nhs.net</a><br>"
                }
            ],
            address: "590 Seven Sisters Road, London, N15 6HR",
            phone: ["0208 801 3999"],
            location: {
                lat: 51.5773308,
                lng: -0.08289360000003398
            }
        },
        {
            name: "HAGA Alcohol Service",
            description: "Contact ${name}",
            location: { lat: 51.6025827, lng: -0.059929000000011 },
            address: "590 Seven Sisters Road, London, N15 6HR",
            isPrimaryProvider: true,
            phone: ["0208 801 3999"],
            email: "humankind.haga590hrs@nhs.net",
            times: [
                {
                    title: "Appointments:",
                    info: "<br>To find out more you can call us on 0208 801 3999 or email us on <a href='mailto:humankind.haga590hrs@nhs.net'>humankind.haga590hrs@nhs.net</a>. You can also self-refer via this <a href='https://changeyourtomorrow.co.uk/#areas/HaringeyBEHMHT/referral' target='_blank'>link.</a><br>",
                    times: {
                        monday: [{ start: 900, end: 2000 }],
                        tuesday: [{ start: 900, end: 2000 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            website: "https://www.haga.co.uk"
        },
        {
            name: "DrinkCoach Online Coaching",
            showAtRiskLevel: [RiskLevel.Higher, RiskLevel.Increasing],
            tagline: "<a href='https://bookdrinkcoach.as.me/haringey' target='_blank'>Book</a> your free sessions with an alcohol specialist.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.org.uk/book-online-appointment"
        }
    ]
};
//# sourceMappingURL=Haringey.js.map